<template>
  <button
    type="button"
    class="link"
    :class="{ 'link__arrow-left': props.variation === 'arrow-left' }"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
const props = defineProps<{
  variation?: "arrow-left";
}>();
</script>
